import { BqSelect } from '@beeq/react'
import styled from 'styled-components'

export const StyledBqSelect = styled(BqSelect)`
  &::part(label){
    gap: 0;
    justify-content: space-between;
  }

  &::part(tag__btn-close) {
    display: none;
  }

  &::part(tag__text) {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 85px;
  }

`
